import React, { Component } from 'react'
import $ from 'jquery'

class DeletePersonalData extends Component {
  componentDidMount() {
    $.getScript('https://leads.vastreach.com/scripts/form_finder.js')
  }

  render() {
    return (
      <div
        class="vast_reach_custom_form"
        data-vast-form-id="029579ac-616e-402a-a234-8a632934b201"
      />
    )
  }
}

export default DeletePersonalData
